import { useMemo, useState } from 'react';
import { AbyssIcon } from '@/assets/icons/AbyssIcon';
import { Button } from '@mui/material';
import { ReportInternalType } from '@/__generated__/graphql';
import { AddToComponentReport } from '@/components/shared/ReportsRevamped/ComponentReports/AddToComponentReport';
import { useAtomValue } from 'jotai';
import * as state from '@/components/Analysis/state';

export const GenerateReport = ({
  variant = 'sm',
  useSelectedComponent = false,
  disabled = false,
  location = 'review-panel',
}: {
  variant?: 'lg' | 'sm';
  useSelectedComponent?: boolean;
  disabled?: boolean;
  location?: string;
}) => {
  const [createReportModalOpen, setCreateReportModalOpen] = useState(false);
  const handleOpen = () => setCreateReportModalOpen(true);
  const handleClose = () => setCreateReportModalOpen(false);

  const selectedAssemblyId = useAtomValue(state.selectedAssemblyId);

  const componentIds = useMemo(() => {
    if (useSelectedComponent && selectedAssemblyId) {
      return [selectedAssemblyId];
    }
    return [];
  }, [useSelectedComponent, selectedAssemblyId]);

  return (
    <>
      <Button
        variant="contained"
        size={variant === 'lg' ? 'large' : 'small'}
        startIcon={<AbyssIcon iconName="report" size={variant === 'lg' ? 'lg' : 'md'} />}
        onClick={handleOpen}
        disabled={disabled || (useSelectedComponent && !selectedAssemblyId)}
        fullWidth={variant === 'lg'}
        id={`${location}-generate-report-button`}
      >
        Generate Report
      </Button>
      <AddToComponentReport
        title="Generate report"
        open={createReportModalOpen}
        handleClose={handleClose}
        componentIds={componentIds}
        internalType={ReportInternalType.Component}
        openComponentReportDialog={handleOpen}
        id={`${location}-generate-report-modal`}
      />
    </>
  );
};
